var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.cellStartedEdit)?_c('v-text-field',{ref:"input",attrs:{"type":"number"},on:{"keydown":function($event){return _vm.onKeyDown($event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_c('span',[_vm._v(_vm._s(_vm.params.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }